import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
    createStyles({
        component: {
            marginTop: "1.8rem",
            width: "100%",
            height: "182px",
            backgroundColor: "#FFFFFF",
            borderRadius: "2px",
            display: "flex",
        },
        doc: {
            display: "flex",
            margin: "30px",
            marginRight: "10px",
            color: "#938FA3",
        },
        componentDoc: {
            width: "160px",
            height: "30px",
            backgroundColor: "#16325C",
            borderRadius: "46.06px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        componentData: {
            width: "116.6px",
            height: "30px",
            backgroundColor: "#16325C",
            borderRadius: "46.06px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        para: {
            color: "#fff",
            fontWeight: "800",
        },
        align: {
            margin: "10px",
            marginLeft: "20px",
        },
        aligndata: {
            margin: "10px",
            marginLeft: "20px",
        },
        aligndivs: {
            display: "flex",

        },
        alignpont: {
            margin: "10px",
            marginLeft: "120px",
        },
        componentPont: {
            width: "256px",
            height: "26px",
            background: "linear-gradient(90deg, #D65C56 0%, #F8BD08 50%, #2ED227 100%)",
            borderRadius: "46.06px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        aligncomponentstwo: {
            width: "650px",
            marginLeft: "25px",
        },
        alignporc: {
            marginTop: "10px",
            display: "flex",
        },
        alignporctwo: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: "5px",
        },
        alignquant: {
            display: "flex",
            marginTop: "5px",
        },
        componentquant: {
            width: "63.3px",
            height: "30px",
            backgroundColor: "#16325C",
            borderRadius: "46.06px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "2px 120px",
        },
        componentquantwo: {
            width: "63.3px",
            height: "30px",
            backgroundColor: "#16325C",
            borderRadius: "46.06px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "5px 130px",
        },

    })
);

export default useStyles;